import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreLegacyTimelineDetailsReducers, coreLegacyTimelineDetailsWatchers } from './details';
import { coreLegacyTimelineSummaryReducers, coreLegacyTimelineSummaryWatchers } from './summary';

export const coreLegacyTimelineReducers = combineReducers({
	details: coreLegacyTimelineDetailsReducers,
	summary: coreLegacyTimelineSummaryReducers
});

export const coreLegacyTimelineWatchers = combineAllWatchers([ coreLegacyTimelineDetailsWatchers, coreLegacyTimelineSummaryWatchers ]);
